module.exports = __webpack_public_path__ + "static/media/chat_history_widget.b58b3eba.jpg";